import {fetchQuestions} from "../actions";
import {call, put, select} from "redux-saga/effects";
import {IApplicationState} from "../../index";
import {IQuestionApiResponse} from "./types";
import apiCall from "../../../shared/utils/apiCall";
import {mapQuestions} from "./handleFetchQuestions";
import {trackError} from "../../log/actions";
import {LogLevel} from "../../log/types";

export default function* fetchQuestion(questionId: number) {
    try {
        const {questionExists} = yield select(({ settings, game }: IApplicationState) => ({
            questionExists: game.questions[questionId],
        }));

        if (questionExists) {
            return true;
        }

        yield put(fetchQuestions.request());

        const response: IQuestionApiResponse = yield call(apiCall, {
            params: {
                section: "questions",
                method: "get",
                questionIds: questionId,
            }
        });

        const {questions, answers, authors, questionIds} = mapQuestions(response.data);

        yield put(fetchQuestions.success({
            questions,
            answers,
            authors,
            unusedQuestions: questionIds
        }));

        return true;
    } catch (error) {
        yield put(trackError({
            logLevel: LogLevel.Fatal,
            category: "FetchQuestion",
            message: "Failed to fetch question",
            error: error,
            data: {
                questionId: questionId,
            }
        }));

        yield put(fetchQuestions.failure({
            message: error
        }));

        return false;
    }
}